/* tslint:disable */

export class Template {
		Organisation: string;
		Logo: string;
		HeaderBackgroundColor: string;
		HeaderTextColor: string;
		ButtonBackgroundColor: string;
		ButtonTextColor: string;
		ExtraCss: string;
		Id: number;
		Name: string;
		Description: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Template.ts